/**
 * Generate a unique Medical Record Number (MRN) for patients
 * Format: MRN-YYYYMMDD-HHMMSS-RRRR
 * Where:
 * - YYYYMMDD: Current date
 * - HHMMSS: Current time
 * - RRRR: Random 4-digit number
 * 
 * @returns {string} A unique MRN number
 */
export const generateMRN = () => {
  const now = new Date();
  const dateStr = now.getFullYear().toString() +
    (now.getMonth() + 1).toString().padStart(2, '0') +
    now.getDate().toString().padStart(2, '0');
  
  const timeStr = now.getHours().toString().padStart(2, '0') +
    now.getMinutes().toString().padStart(2, '0') +
    now.getSeconds().toString().padStart(2, '0');
  
  const randomStr = Math.floor(Math.random() * 10000).toString().padStart(4, '0');
  
  return `MRN-${dateStr}-${timeStr}-${randomStr}`;
};

/**
 * Validate MRN format
 * @param {string} mrn - The MRN to validate
 * @returns {boolean} True if valid MRN format
 */
export const validateMRN = (mrn) => {
  if (!mrn) return false;
  
  // Check if it matches the MRN format: MRN-YYYYMMDD-HHMMSS-RRRR
  const mrnPattern = /^MRN-\d{8}-\d{6}-\d{4}$/;
  return mrnPattern.test(mrn);
};

/**
 * Format MRN for display (adds spaces for readability)
 * @param {string} mrn - The MRN to format
 * @returns {string} Formatted MRN
 */
export const formatMRN = (mrn) => {
  if (!mrn) return '';
  
  // If it's already in the correct format, return as is
  if (validateMRN(mrn)) {
    return mrn;
  }
  
  // If it's just a string without format, return as is
  return mrn;
}; 